var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mating-list-container card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('mating-list-card')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-header d-flex align-items-center"},[_c('h3',[_vm._v("Mating List")])])
}]

export { render, staticRenderFns }